import Panel from "@/components/ui/Panel";
import { SANDBOX, sandboxedSection } from "./sandboxedHtml";

// Organizer-written HTML and CSS. The terms it renders under live in
// sandboxedHtml, shared with hosted attendee sites.
//
// It stays inside a Panel rather than going full-bleed, so a custom section
// always reads as the organizer's own box and can never be mistaken for a
// platform control the attendee is meant to trust.
export default function CustomHtmlFrame({
  html,
  height,
}: {
  html: string;
  height: number;
}) {
  return (
    <Panel title="custom.html" bodyClassName="p-0">
      <iframe
        title="A section written by the organizer"
        srcDoc={sandboxedSection(html)}
        sandbox={SANDBOX}
        referrerPolicy="no-referrer"
        style={{ height }}
        className="block w-full border-0"
      />
    </Panel>
  );
}
